import { render } from "./CurrentPageReport.vue?vue&type=template&id=780bcfee"
import script from "./CurrentPageReport.vue?vue&type=script&lang=js"
export * from "./CurrentPageReport.vue?vue&type=script&lang=js"
script.render = render

export default script